<script>
import Heart from "./Heart";

export default {
  name: "WishlistTeaser",
  components: {
    Heart
  },
  props: {
    id: String,
    type: String,
    title: String,
    price: String,
    category: null,
    image: String,
    url: String,
  },
  setup(props) {
    return props
  },
  mounted() {
    // from Sources/JavaScript/General/IconSwitch.js
    window.switchIconsOnRoot(this.$el);
  },
  computed: {
    imageSrc() {
      if (this.image) {
        return this.image;
      }
      let svg = '<svg xmlns="http://www.w3.org/2000/svg" width="340" height="260">' +
        '<rect x="0" y="0" width="340" height="260" fill="#cfd5ce" />' +
        '</svg>';
      return 'data:image/svg+xml;base64,' + btoa(svg);
    }
  }
}
</script>


<template>
  <div class="teaser teaser--tiny mb-4">
    <a :href="url" class="teaser__inner">
      <Heart :id="id"
             :absolute="true"
             :type="type"
             :title="title"
             :price="price"
             :category="category"
             :image="image"
             :url="url"/>

      <div class="teaser__image-wrap">
        <picture class="teaser__image-picture">
          <img class="teaser__image" :src="imageSrc" width="340" height="260" alt="">
        </picture>
      </div>
      <div class="teaser__text-wrap" :class="{'justify-content-end': !(category && category.icon)}">
        <div v-if="category && category.icon" class="teaser__category">
          <div class="teaser__category-icon">
            <i :class="category.icon"></i>
          </div>
        </div>
        <div class="teaser__title-wrap teaser__title-wrap--hoverable">
          <div class="teaser__title">
            {{ title }}
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
